export const layout_alt = () => (
  <path
    d="M13 3H3v7h10V3zM21 3h-4v7h4V3zM21 14h-9v7h9v-7zM8 14H3v7h5v-7z"
    strokeLinecap="round"
    strokeLinejoin="round"
  />
);
